import AppInsightMonitoringService from "./AppInsightsMonitoringService";
import type { MonitoringService } from "./MonitoringService";
import DebugMonitoringService from "@core/shared/services/monitoring/DebugMonitoringService";
import isDev from "@env/helpers/DevDetect";

interface MonitoringTools {
  [key: string]: MonitoringService;
}

class Monitoring {
	monitoringTools: MonitoringTools = {};

	constructor(connectionString: string) {
		this.monitoringTools["APP_INSIGHT"] = (new AppInsightMonitoringService(connectionString));
    if(isDev()) {
      this.monitoringTools["DEBUG"] = (new DebugMonitoringService);
    }
	}

	public trackError(error: string): void {
    (Object.keys(this.monitoringTools) as (keyof MonitoringTools)[]).forEach((key) => {
      this.monitoringTools[key].trackError(error);
    });
	}

	public trackEvent(event: string): void {
    (Object.keys(this.monitoringTools) as (keyof MonitoringTools)[]).forEach((key) => {
      this.monitoringTools[key].trackEvent(event);
    });
	}

	public trackTrace(trace: string): void {
    (Object.keys(this.monitoringTools) as (keyof MonitoringTools)[]).forEach((key) => {
      this.monitoringTools[key].trackTrace(trace);
    });
	}

  public get services(): MonitoringTools {
    return this.monitoringTools;
  }
}

export default Monitoring;
